import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEdit3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill='currentColor'
      d='M12 19a1 1 0 1 0 0 2zm9 2a1 1 0 1 0 0-2zM16.5 3.5l-.707-.707zm1.5-.621v-1zM20.121 5h-1zM19.5 6.5l-.707-.707zM7 19l.243.97a1 1 0 0 0 .464-.263zm-4 1-.97-.242a1 1 0 0 0 1.213 1.212zm1-4-.707-.707a1 1 0 0 0-.263.465zm8 5h9v-2h-9zm5.207-16.793c.21-.21.496-.328.793-.328v-2c-.828 0-1.622.329-2.207.914zM18 3.88c.147 0 .293.029.43.085l.765-1.848A3.1 3.1 0 0 0 18 1.88zm.43.085c.135.056.259.139.363.243l1.414-1.414a3.1 3.1 0 0 0-1.012-.677zm.363.243q.157.158.243.364l1.848-.765a3.1 3.1 0 0 0-.677-1.013zm.243.364c.056.136.085.282.085.429h2c0-.41-.08-.816-.237-1.194zm.085.429c0 .147-.029.293-.085.43l1.848.764A3.1 3.1 0 0 0 21.12 5zm-.085.43c-.056.135-.139.259-.243.363l1.414 1.414c.29-.29.52-.634.677-1.013zm-.243.363-12.5 12.5 1.414 1.414 12.5-12.5zM6.757 18.03l-4 1 .486 1.94 4-1zM3.97 20.242l1-4-1.94-.485-1 4zm.737-3.535 12.5-12.5-1.414-1.414-12.5 12.5z'
    />
  </svg>
);
export default SvgEdit3;
